module.exports = __webpack_public_path__ + "img/portrait-sara-lachend.969075f6.webp";